const $ = jQuery.noConflict();
import 'slick-carousel';

const sliders = document.querySelectorAll('.component-slider');

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		if (sliders.length) {
			sliders.forEach((slider) => {
				if (slider.childElementCount) {
					slider.setAttribute(
						'data-slide-count',
						slider.childElementCount
					);
				}

				if (!slider.hasAttribute('data-slick')) {
					const parentWithSettings = slider.closest('[data-slick]');

					if (parentWithSettings) {
						slider.setAttribute(
							'data-slick',
							parentWithSettings.getAttribute('data-slick')
						);
					}
				}
			});

			$('.component-slider[data-slick*="pageCount"]').on(
				'init reInit afterChange',
				function (event, slick, currentSlide, nextSlide) { // eslint-disable-line
					if (!slick.$dots) {
						return;
					}

					if (slick.$dots[0].children.length) {
						slick.$dots[0].removeAttribute('role');

						Array.from(slick.$dots[0].children).forEach(
							(dot, index) => {
								dot.classList.add('slick-dot--page-count');

								if (dot.firstElementChild) {
									dot.innerHTML = '';
									const dotContent =
										document.createElement('span');
									dotContent.setAttribute('role', 'tab');
									dotContent.textContent =
										index +
										1 +
										'/' +
										slick.$dots[0].children.length;

									dot.appendChild(dotContent);
								}
							}
						);
					}
				}
			);

			$('.component-slider').slick();

			$(window).on('block-library-change', function () {
				$('.component-slider').slick('refresh');
			});
		}
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
